import React, { useCallback, useRef, useEffect, useState } from 'react';

import { IconType } from 'react-icons/lib';
import { Link } from 'react-router-dom';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import api from '../../services/api';
import { date, hour, dateLanguage,simpleDate } from '../../utils/date';
import { Container } from './styles';
import {addHours} from 'date-fns';
import { useToast } from '../../hooks/Toast';
import { Form } from '@unform/web';
import Button from '../Button';
import SelectSimple from '../Forms/SelectSimple';
import { string } from 'yup';
import Favorite from '../ClassRoomContainer/modules/Favorite';
import { useLanguage } from '../../hooks/Language';

interface IOption {
  value : string;
  label : string;
}

interface IProgram {
  date: Date;
  formatted_date?: string;
  start_hour: Date;
  formatted_start_hour?: string;
  end_date: Date;
  formatted_end_date?: string;
  title: string;
  category : string;
  room_reference_id_response: Record<string, any>;
  description: string;
}

interface IProgramFilter {
  formatted_date: string;
  program: Array<IProgram>;
  simpleDate ?: string;
}

const Program: React.FC = () => {
  const [programs, setPrograms] = useState<Array<IProgramFilter>>([]);
  const [referenceProgram, setReferenceProgram] = useState<Array<IProgramFilter>>([]);
  const [currentDay, setCurrentDay] = useState(0);

  const [search, setSearch] = useState('');
  const [roomList, setRoomList] = useState<Array<IOption>>([]);
  const { addToast} = useToast();
const {translate} = useLanguage();
  const [filter, setFilter] = useState({
    date : '',
    category : '',
    search : ''
  });

  const addFilter = (column, value) => {

    const newFilter = {...filter};
    newFilter[column] = value;

    setFilter(newFilter);

  }

  const newSearch = ( data ) => {

    const newFilter = {...filter};
    newFilter.search = search;

    setFilter(newFilter);

  }

  useEffect(() => {

    let programsContent : Array<IProgramFilter> = [];

    if(filter.date){
      programs.map( p => {
        if(p.simpleDate === filter.date){
          programsContent.push({...p});
        }
      })
    }
    else{
      programsContent = [...programs];
    }



    if(filter.category !== ""){
      const filteredProgram : Array<IProgramFilter> = [];
      programsContent.map(( item, index) => {
        filteredProgram.push({...item, program : []});
        return false;
      })
    
      programsContent.map( (p1) => {

        const index = filteredProgram.findIndex( p => p.simpleDate === p1.simpleDate);
       if(index >= 0){
        p1.program.map( p1_program => {
          const text = p1_program?.category?.toString()?.toLowerCase();
          const searchValue = filter?.category?.toString()?.toLowerCase();

          const indexText = text === searchValue;

    
          if(indexText){
            
            filteredProgram[index].program.push(p1_program);
          }
        }) }
      })

      programsContent = [...filteredProgram]; 
    }

 

    if(filter.search !== ""){
      const filteredProgram : Array<IProgramFilter> = [];
      programsContent.map(( item, index) => {
        filteredProgram.push({...item, program : []});
        return false;
      })
    
      programs.map( (p1) => {

        const index = filteredProgram.findIndex( p => p.simpleDate === p1.simpleDate);
       if(index >= 0){
        p1.program.map( p1_program => {
          const text = p1_program?.title?.toString()?.toLowerCase();
          const text2 = p1_program?.description?.toString()?.toLowerCase();
          const searchValue = filter?.search?.toString()?.toLowerCase();
          let indexText = text?.indexOf(searchValue);

          if(indexText < 0){
            indexText = text2?.indexOf(searchValue);

          }

          
          if(indexText >= 0){
            
            filteredProgram[index].program.push(p1_program);
          }
        }) }
      })

      programsContent = [...filteredProgram]; 
    }

    setReferenceProgram(programsContent);

  },[programs,filter])

  const checkUser = async(id) => {

    try{
      const response = await api.post(`/check-activity/${id}`);

      if(response && response.data){
        window.open(response?.data?.url,'_BLANK');
      }
      else{
addToast({type:"error", title: "Inscrição não encontrada"});
      }


    } catch (err) {
      addToast({type:"error", title: "Inscrição não encontrada"});
    }
  }

  useEffect(() => {
    const load = async () => {
      const program_ref: Array<IProgramFilter> = [];

      const response = await api.get('/programs-list');
      const rooms = {};
      if (response && response.data && response.data.rows) {
        const responseData = response.data.rows.reduce((prev, elem) => {
          elem.simpleDate = simpleDate(elem.date);
          elem.formatted_date = dateLanguage(elem.date);
          elem.formatted_start_hour = hour(elem.start_hour);
          elem.formatted_end_hour = hour(elem.end_hour);

          if(elem.category){
          rooms[elem.category] = '';
          }
        
          prev.push(elem);

          return prev;
        }, []);

        const itens : Array<IOption> = [];
        Object.keys(rooms).map( key => {
          itens.push({ label : key, value : key});
        })


        setRoomList(itens)

        if (responseData) {
          responseData.map(rep => {
            const index = program_ref.findIndex(
              day => day.formatted_date === rep.formatted_date,
            );

            if (index < 0) {
              program_ref.push({
                simpleDate: rep.simpleDate,
                formatted_date: rep.formatted_date,
                program: [{ ...rep }],
              });
            } else {
              program_ref[index].program.push({ ...rep });
            }
          });
        }

        setPrograms(program_ref);
        setReferenceProgram(program_ref);
      }
    };
    load();
  }, []);

  const line = program => {
    return (
      <tr>
        <td style={{width:'100%'}}>
         
            <span>
              {`
              ${program.formatted_start_hour}
              ${program.formatted_end_hour && `às ${program.formatted_end_hour}`}`} {program.category ? <><span style={{fontSize: '12px', color: 'rgb(0,100,0)', fontWeight:'bold'}}> - {program.category} </span></> : <></> }
                        <br/>  <strong>
{' '}

{program.title}
{' '}


 </strong>

 {program.description && <div>
            <div style={{width: '100%'}}>


            <div className="miniPrograma" dangerouslySetInnerHTML={{ __html: program.description }} />

            </div>


          </div>}
            </span>
            </td><td><div>
            <span>
              {program.room_reference_id_response &&
                program.room_reference_id_response.title}

{program.link_url && (
              <a href={program.link_url} target="_BLANK">
                <button className="defaultButtonMini buttonBlue" type="button">
                  {' '}
                  <FiChevronRight />
                </button>
              </a>
            )}

{program.activity_id  > 0 && (

                <button onClick={() => checkUser(program.activity_id)} className="defaultButtonMini buttonBlue" type="button">
                  {' '}
                  <FiChevronRight />
                </button>

            )}

                      {program.video_id && (
                        <div style={{display:'flex', alignItems:'center'}}>
                         <button className="defaultButtonMini" type="button"><Favorite type="lesson" subtype="star" id={program.video_id}/></button>
              <Link to={`/dashboard/${program.video_id}`} style={{margin: '5px'}}>
                <button className="defaultButtonMini" type="button">
                  {' '}
                  <FiChevronRight style={{margin: '0px 2px'}} size={24} />
                </button>
              </Link></div>
            )}
            </span>
          </div>
          </td>
      
      </tr>
    );
  };
  const {length} = programs;
  return (
    <Container>
      <h2>{translate('Programação')}</h2>
      <p style={{textAlign:'center', width:'100%'}}>Horário de Brasilia</p>
<div style={{display:'flex', flexDirection:'row', alignContent:'center', justifyContent:'center', width:'100%'}}>
<button style={{width: '60px', margin: '5px', background : filter.date === '' ? 'rgb(58,128,79)' : '#fff' , color: filter.date === '' ? '#fff' : 'rgb(58,128,79)', border: '2px solid rgb(58,128,79)' }} onClick={() => addFilter('date','')}>{translate('Todos')}</button>
      {programs.map( filterday => {
        return <button style={{width: '60px', margin: '5px', background : filter.date === filterday.simpleDate ? 'rgb(58,128,79)' : '#fff', color: filter.date === filterday.simpleDate ? '#fff' : 'rgb(58,128,79)', border: '2px solid rgb(58,128,79)' }}  onClick={() => addFilter('date',filterday.simpleDate)}>{translate(filterday.simpleDate)}</button>
      })}

</div>
<div style={{display:'flex', flexDirection:'row', alignContent:'center', justifyContent:'center', width:'100%'}}>
<Form
          style={{ display: 'flex', alignItems: 'stretch', background:'none' }}
          onSubmit={newSearch}
        >
          
           
          <input style={{height: '43px', padding: '10px'}}
            name="pesquisa"
            type="text"
            placeholder={`${translate('Escreva para pesquisar')}...`}
            value={search}
            onChange={e => setSearch(e.target.value)}
          />

        <button style={{width: '100px',height: '43px', background:'rgb(58,128,79)', color: '#fff', borderRadius:'10px', border: '0px',  margin: '0px 5px'}} type="submit">{translate('Pesquisar')}</button>
        </Form>
    
</div>

<div style={{display:'flex', flexDirection:'row', alignContent:'center', justifyContent:'center', width:'100%'}}> 
        <strong style={{margin: '10px'}}>{translate('Sala')}</strong><select style={{width: '250px', padding: '11px'}} onChange={(e) => { addFilter('category', e.target.value); console.log(e.target.value)}} name="category" >
      <option value="">{translate('Todas as salas')}</option>
      {roomList.map( room => <option value={room.value}>{room.label}</option>)}
          </select></div>


      {referenceProgram.map( program => {
return (program.program.length > 0 ? <div>
<div className="programDayHeader" >
      
        
            <h2 style={{background: 'rgb(58,128,79)', color: '#fff', padding: '10px', marginLeft: '7px'}}>{translate(program.formatted_date)}</h2>

          </div>
          <table>
           
            <tbody>{program.program.map(items => line(items))}</tbody>
          </table>

</div> : <></>)
      })}

    </Container>
  );
};
export default Program;
